import { createContext, useCallback, useContext, useState } from "react";

const QuoteContext = createContext(null);

export const QuoteProvider = ({ children }) => {
  const [state, setState] = useState({ open: false, service: null });
  const openQuote = useCallback((service = null) => setState({ open: true, service }), []);
  const closeQuote = useCallback(() => setState((s) => ({ ...s, open: false })), []);
  return (
    <QuoteContext.Provider value={{ ...state, openQuote, closeQuote }}>
      {children}
    </QuoteContext.Provider>
  );
};

export const useQuote = () => useContext(QuoteContext);
